import React from "react";

type Props = {
    className?: string,
    text?: string,
    textColour?: string,
    backgroundColour?: string,
};

const ArrowBox: React.FC<Props> = ({
    className = "",
    text = "On sale!",
    textColour = "white",
    backgroundColour = "red",
}) => (
    <div className={className}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 318.471 186.862">
            <g transform="translate(0)">
                <g transform="matrix(0.174, 0.985, -0.985, 0.174, 294.684, 0)">
                    <g transform="translate(0 0)" clipPath="url(#clip-path)">
                        <path d="M136.761,100.18A24.641,24.641,0,0,0,132.906,86.7L80.023,7.028C73.8-2.354,62.71-2.341,56.506,7.057L3.821,86.857A24.645,24.645,0,0,0,0,100.35L.222,278.718C.236,290.057,7.23,299.24,15.844,299.23l105.567-.131c8.614-.011,15.585-9.211,15.571-20.55ZM86.541,59.2A18.671,18.671,0,1,1,73.266,36.38,18.671,18.671,0,0,1,86.541,59.2" transform="translate(0 0)" fill={`${backgroundColour}`} />
                    </g>
                </g>
                <text transform="translate(35.162 127.535) rotate(-11)" fontSize="41" fill={`${textColour}`}><tspan x="0" y="0">{text}</tspan></text>
            </g>
        </svg>
    </div>
);

export default ArrowBox;
